export default "__VITE_ASSET__CPfFYRnC__"